import Snackbar from '@material-ui/core/Snackbar';
import { makeStyles } from '@material-ui/core/styles';
import { AlertTitle } from '@material-ui/lab';
import MuiAlert from '@material-ui/lab/Alert';
import React, { useState } from 'react';

function Alert({ severity, handleAlertClose, alertAction, ...rest }) {
  return (
    <MuiAlert
      elevation={6}
      variant="filled"
      severity={severity}
      onClose={handleAlertClose}
      // for alertActon, i am already sending a method from the component to this re-useable component.
      // so now when someone clicks on the snackbar action, the method from the component will be triggered.
      // but when it is clicked, i want to remove the snackbar.
      // Maybe i can return something from the component which will then be used here to hide the snackbar ?
      action={alertAction}
      {...rest}
    />
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  alertTitle: {
    color: 'white',
  },
}));

function CustomSnackbar({
  open,
  autoHideDuration,
  message,
  severity,
  alertTitle,
  onClose,
  alertAction,
}) {
  const classes = useStyles();
  const [close, setClose] = useState(false);

  const handleAlertClose = event => {
    setClose(true);
    if (onClose) onClose(event);
  };

  return (
    <div className={classes.root}>
      <Snackbar open={open && !close} autoHideDuration={autoHideDuration || 6000}>
        <Alert severity={severity} onClose={handleAlertClose} action={alertAction}>
          {alertTitle && <AlertTitle className={classes.alertTitle}>{alertTitle}</AlertTitle>}
          {message ||
            (severity === 'error'
              ? 'Something went wrong. Please try again later.'
              : 'Action performed successfully.')}
        </Alert>
      </Snackbar>
    </div>
  );
}

export { CustomSnackbar };
